import React from 'react';
import { motion } from 'framer-motion';
export function ProductGalleryBottom() {
  return <section className="bg-black py-16 px-4" data-id="element-69">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="overflow-hidden" data-id="element-71">
          <img src="https://cdn.magicpatterns.com/uploads/7eQUgDd6ShzaAevWh5gHPz/privaMisey_hats_nanobana.png" alt="Detalle interior de seda magenta y bordado Misery Hats" className="w-full h-[500px] object-cover hover:scale-105 transition-transform duration-700" data-id="element-72" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} className="text-center space-y-3" data-id="element-73">
          <p className="font-inter text-gray-400 text-lg" data-id="element-74">
            El lujo está en los detalles que nadie más ve.
          </p>
          <a href="https://www.misery.lat/cart/52836345020715:1" target="_blank" rel="noopener noreferrer" className="inline-block bg-misery-purple hover:bg-misery-magenta transition-all duration-300 text-white font-bebas text-2xl md:text-3xl px-12 py-5 tracking-wider transform hover:scale-105" data-id="element-75">
            CONSÍGUELO AHORA
          </a>
        </motion.div>
      </div>
    </section>;
}